import {MyopMessages} from "../../common/MyopMessages";
import {BaseMessageHandler} from "../../common";
import {BindClickMessage, ClickReplayMessage} from "../../messages";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class BindOnClickHandler extends BaseMessageHandler<BindClickMessage> {

    messageType = MyopMessages.BindClickMessage;

    executor = (event: BindClickMessage) => {
        const cleanupTasks: (() => void)[] = [];

        const items = getElementsByRef(event.ref, document);
        items.forEach(item => {
            const handler = () => {
                this.messageToHost(new ClickReplayMessage(), event);
            };
            item.addEventListener('click', handler);

            const cleanUpTask = () => {
                item.removeEventListener('click', handler)
            }
            cleanupTasks.push(cleanUpTask);
        });

        //clean up
        return () => {
            cleanupTasks.forEach(task => task());
        }
    }
}
